interface PaddingOptions {
	bottom?: number;
	left?: number;
	right?: number;
	top?: number;
}

/**
 * Creates a css string for padding options
 *
 * @param {PaddingOptions | undefined} paddingOptions - padding options, can be undefined
 * @return {string} css string of the padding options applied. For example: 'padding-left: 12px;'
 */
export const customPadding = (paddingOptions: PaddingOptions | undefined): string => {
	if (paddingOptions === undefined) {
		return '';
	}

	return Object.entries(paddingOptions)
		.map(([option, value]) => `padding-${option}: ${value}px;`)
		.join('\n');
};
